'use client';

import { cn } from '@/lib/utils';

interface StreakBadgeProps {
  streakCount?: number;
  className?: string;
}

export function StreakBadge({ streakCount = 7, className = '' }: StreakBadgeProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-1.5 bg-[#0d1117] px-3 py-1.5 rounded-full text-reading-sm border border-slate-700/30',
        className
      )}
    >
      <span className="text-reading-sm">🔥</span>
      <span className="font-semibold text-[#d4a853]">{streakCount}</span>
      <span className="text-[#8b949e] hidden sm:inline">day streak</span>
    </div>
  );
}
